import { Control, FieldErrors } from "react-hook-form";
import { Controller } from "react-hook-form";
import { Autocomplete, Stack, TextField, Typography } from "@mui/material";
import { textFieldStyle } from "../../../theme";
interface AutocompleteFieldProps {
  control: Control<any>;
  errors?: FieldErrors<any>;
  options: any[];
  name?: string;
  label?: string;
  title?: string;
  required?: boolean;
  disabled?: boolean;
}


export function AutoCompleteField({
  control,
  errors,
  options,
  name = "companyId",
  title = "Concessionária",
  label = "Concessionária",
  required = true,
  disabled = false,
}: AutocompleteFieldProps) {
  return (
    <Stack
      direction="row"
      width="100%"
      justifyContent="space-between"
      alignItems="center"
    >
      <Typography fontWeight={400} display={"flex"} width="400px">
        {title ??"Concessionária"}
      </Typography>

      <Controller
        name={name}
        control={control}
        rules={
          required
            ? { required: `${label} é obrigatória` }
            : undefined
        }
        render={({ field }) => (
          <Autocomplete<any, false, false, false>
            options={options}
            fullWidth
            disabled={disabled}
            getOptionLabel={(option) => option.label ?? ""}
            isOptionEqualToValue={(option, value) =>
              option.id === value.id
            }
            value={
              options.find(
                (option) => option.id === field.value
              ) ?? null
            }
            onChange={(_, newValue) => {
              field.onChange(newValue ? newValue.id : null);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={textFieldStyle}
                label={label}
                placeholder={` ${label.toLowerCase()}`}
                error={!!errors?.[name]}
                helperText={
                  errors?.[name]?.message as string | undefined
                }
              />
            )}
          />
        )}
      />
    </Stack>
  );
}
